export const init = () => {
    const observer = new MutationObserver(() => {
        const switcherTabs = document.querySelectorAll('.s-switcher-tab.js-apply-switch');
        if (!switcherTabs.length) return;

        observer.disconnect(); // Odpojí observer během inicializace, aby se vyhnul nekonečné smyčce

        switcherTabs.forEach(switcherTab => {
            // Kontrola, zda již byl přepínač inicializován
            if (switcherTab.dataset.initialized === 'true') return;

            const links = switcherTab.querySelectorAll('.s-switcher-tab__link');
            const contents = switcherTab.querySelectorAll('.s-switcher-tab__content');

            if (window.innerWidth > 1055 || switcherTab.classList.contains('s-switcher-tab--with-icon')) {
                hideInactiveContents(contents);
                links.forEach(link => {
                    link.firstElementChild.addEventListener('click', () => {
                        handleLinkClick(link, links, contents);
                    });
                });
            } else {
                hideAllContents(contents);
                links.forEach(link => {
                    if (link.classList.contains('active')) {
                        movingContentsToLinks(link, contents);
                    }
                    link.firstElementChild.addEventListener('click', () => {
                        toggleLinkActiveState(link, contents);
                    });
                });
            }

            // Označení přepínače jako inicializovaného
            switcherTab.dataset.initialized = 'true';
        });

        // Opětovné připojení observeru po dokončení inicializace
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
};

// Skryje neaktivní obsahy přepínače záložek.
const hideInactiveContents = contents => {
    contents.forEach(content => {
        if (!content.classList.contains('active')) {
            content.style.display = 'none';
        }
    });
};

// Skryje všechny obsahy přepínače záložek.
const hideAllContents = contents => {
    contents.forEach(content => {
        content.style.display = 'none';
    });
};

// Obsluhuje událost kliknutí na odkaz přepínače záložek.
const handleLinkClick = (clickedLink, allLinks, allContents) => {
    const linkId = clickedLink.dataset.id;
    allLinks.forEach(link => link.classList.toggle('active', link === clickedLink));

    allContents.forEach(content => {
        const contentId = content.dataset.id;
        content.style.display = contentId === linkId ? '' : 'none';
        if (contentId === linkId) {
            setTimeout(() => content.classList.add('active'), 100);
        } else {
            content.classList.remove('active');
        }
    });
};

// Přepíná stav aktivní/neaktivní kliknutého odkazu přepínače záložek.
const toggleLinkActiveState = (clickedLink, contents) => {
    // Pro všechny odkazy přepínače záložek
    const links = Array.from(clickedLink.parentElement.children);
    links.forEach(link => {
        // Odebere třídu "active" všem odkazům kromě toho, na který bylo kliknuto.
        if (link !== clickedLink) {
            link.classList.remove('active');
            link.lastElementChild.removeAttribute('style');
            link.lastElementChild.classList.remove('active');
        }
    });
    // Přidá nebo odebere třídu "active" kliknutému odkazu.
    clickedLink.classList.toggle('active');
    // Přesune obsah odpovídající kliknutému odkazu.
    movingContentsToLinks(clickedLink, contents);
};

// Přesune obsah odpovídající kliknutému odkazu přepínače záložek.
const movingContentsToLinks = (link, contents) => {
    // Pokud poslední potomek odkazu nemá maximální výšku, provede se následující:
    if (!link.lastElementChild.style.maxHeight) {
        contents.forEach(content => {
            // Pokud je ID obsahu shodné s ID odkazu, přesune se obsah k odkazu.
            if (link.dataset.id === content.dataset.id) {
                link.appendChild(content);
                content.removeAttribute('style');
                content.classList.add('active');
            }
        });
        // Nastaví maximální výšku posledního potomka odkazu.
        link.lastElementChild.style.maxHeight = link.lastElementChild.scrollHeight + 'px';
    } else {
        // Pokud má poslední potomek odkazu maximální výšku, odeberou se styly a třída "active".
        link.lastElementChild.removeAttribute('style');
        link.lastElementChild.classList.remove('active');
    }
};